import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './ContactButton.scss';
import kakaoTalkIcon from '../../images/icons/kakao-talk.png';

const ContactButton = () => {
  const handleKakaoClick = () => {
    // 카카오톡 1:1 오픈채팅 링크로 이동
    window.open('https://open.kakao.com/o/sgFGe9Ri', '_blank', 'noopener,noreferrer');
  };

  return (
    <motion.button
      className="contact-button"
      onClick={handleKakaoClick}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <span className="contact-button__icon">
        <img src={kakaoTalkIcon} alt="카카오톡" />
      </span>
    </motion.button>
  );
};

export default ContactButton;

